import React, {FC} from 'react';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween'

import { Anket } from './Anket';
import { Countdown } from './Countdown';
import { Expire } from './Expire';

dayjs.extend(isBetween)

const Index: FC = () => {

    const startDate = dayjs('2024-07-10T08:00:00+03:00')
    const endDate = dayjs('2024-07-12T17:00:00+03:00')

    return (
        <>

            {dayjs().isBefore(startDate) && <Countdown startDate={startDate}/>}
            {dayjs().isBetween(startDate, endDate) && <Anket/>}
            {dayjs().isAfter(endDate) && <Expire/>}

        </>
    )
}

export default Index;



